import { useCallback } from "react";
import { UserSchema } from "@common/schemas/user.schema";
import { userStatusQueryKey } from "@api/user.api";
import { ACTIVE_USER_ID_KEY } from "@constants";
import { safeLocalStorage } from "@helpers/storage";
import { queryClient } from "../queryClient";
import { useUserStatus } from "./useUserStatus";

export function useUpdateUser() {
    const { data: status } = useUserStatus();

    return useCallback(
        (updatedUser: UserSchema) => {
            if (!status) {
                return;
            }

            queryClient.setQueryData([userStatusQueryKey], {
                ...status,
                user: updatedUser,
            });

            safeLocalStorage.setItem(
                ACTIVE_USER_ID_KEY,
                updatedUser.id.toString(),
            );
        },
        [status],
    );
}
